import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable, of } from 'rxjs'

import { catchError, concatMap, map, toArray } from 'rxjs/operators'

import { ChargeResponse, CreateChargePayload, UpdateChargePayload } from './model'
import * as lodash from 'lodash'

@Injectable()
export class ChargeService {
  constructor(private http: HttpClient) {}

  all(): Observable<ChargeResponse[]> {
    const url = `@api/charge/all`
    return this.http.get<ChargeResponse[]>(url)
  }

  get(id: string) {
    const url = `@api/charge/${id}`

    return this.http.get<ChargeResponse>(url)
  }

  getByIds(ids: string[]) {
    return of(...ids).pipe(
      concatMap((id) => this.get(id).pipe(catchError(() => of(null)))),
      toArray(),
      map((items) => items.filter((t) => !lodash.isNil(t)) as ChargeResponse[])
    )
  }

  create(request: CreateChargePayload) {
    const url = '@api/charge/'

    return this.http.post<ChargeResponse>(url, request)
  }

  update(chargeId: string, payload: UpdateChargePayload) {
    const url = `@api/charge/${chargeId}`

    return this.http.put<ChargeResponse>(url, payload)
  }

  delete(chargeId: string) {
    const url = `@api/charge/${chargeId}`

    return this.http.delete<ChargeResponse>(url)
  }

  deleteCharges(chargeIds: string[]) {
    return of(...chargeIds).pipe(
      concatMap((id) => this.delete(id)),
      toArray()
    )
  }
}
